import React, { useState, useEffect, useCallback } from "react";
import { Layout, Radio } from "antd";
import { withRouter } from "react-router-dom";
import CostSummary from "../CostSummary/CostSummary";
import ModelCostDetails from "../ModelCostDetails/ModelCostDetails";
import ModelsWarning from "../ModelsWarning/ModelsWarning";
import { WarningOutlined, ExperimentOutlined, InfoCircleOutlined } from '@ant-design/icons';
import ENVIRONMENT from "../../../../environments";
import axios from "axios";
import { filterRecordsByPattern } from "../../Utilities";

const { Content } = Layout;

const COMPANY_NAME_FILTERS = [
  "Google Signup",
  "%test%",
  "%tintash%",
  "NA"
];

const ModelingCostReport = ({ history, location }) => {
  const [companies, setCompanies] = useState([]);
  const [modelStatus, setModelStatus] = useState("approved");
  const [isInitialized, setIsInitialized] = useState(false);

  // URL parameter parsing
  const parseURLParams = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    
    return {
      modelStatus: searchParams.get('modelStatus') || 'approved'
    };
  }, [location.search]);

  // URL updating
  const updateURL = useCallback((filters) => {
    const searchParams = new URLSearchParams(location.search);
    
    if (filters.modelStatus !== undefined) {
      if (filters.modelStatus === 'approved') {
        searchParams.delete('modelStatus');
      } else {
        searchParams.set('modelStatus', filters.modelStatus);
      }
    }

    const newURL = `${location.pathname}?${searchParams.toString()}`;
    history.replace(newURL);
  }, [location.search, location.pathname, history]);

  // Function to handle modelStatus change and update URL params
  const handleModelStatusChange = (value) => {
    setModelStatus(value);
    updateURL({ modelStatus: value });
  };

  const getCompaniesList = () => {
    let payload = {};
    axios.post(ENVIRONMENT.COMPANY_GET_BATCH, payload).then((response) => {
      let companiesData = [{label: "All Companies", value: "all"}];
      if (response.data) {
        const filteredCompanies = filterRecordsByPattern(response.data, 'company_display_name', COMPANY_NAME_FILTERS);
        filteredCompanies.map((request) => {
          companiesData.push({
            label: request.company_display_name, 
            value: request.company_id
          });
        });
        // Sort companies alphabetically by name (excluding "All Companies" which stays first)
        const sortedCompanies = [
          companiesData[0], // Keep "All Companies" at the top
          ...companiesData.slice(1).sort((a, b) => a.label.localeCompare(b.label))
        ];
        setCompanies(sortedCompanies);
      }
    }).catch((error) => {
      console.error("Error fetching companies:", error);
      // Set default companies list on error
      setCompanies([{label: "All Companies", value: "all"}]);
    });
  };

  // Initialize from URL parameters
  useEffect(() => {
    const urlParams = parseURLParams();
    setModelStatus(urlParams.modelStatus);
    setIsInitialized(true);
  }, [parseURLParams]);

  useEffect(() => {
    getCompaniesList();
  }, []);

  return (
    <>
      <Layout>
        <Content className="analytics-content">
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, padding: 8, justifyContent: "flex-end" }}>
            <Radio.Group onChange={(e) => handleModelStatusChange(e.target.value)} value={modelStatus} className="manrope f-14 black-55">
                <Radio.Button value="approved">Approved</Radio.Button>
                <Radio.Button value="inprogess">In-Progess</Radio.Button>
            </Radio.Group>  
          </div>
          {/* High Cost Models */}
          <ModelsWarning
            type="high_cost"
            title="High Cost Models"
            icon={<WarningOutlined style={{ marginRight: 8, fontSize: '20px' }} />}
            borderColor="#ff4d4f"
            backgroundColor="linear-gradient(135deg, #fff5f5 0%, #fff 100%)"
            shadowColor="rgba(255, 77, 79, 0.15)"
            companies={companies}
            modelStatus={modelStatus}
          />
          
          {/* Test Models */}
          <ModelsWarning
            type="get_customers_test_models"
            title="Test Models"
            icon={<ExperimentOutlined style={{ marginRight: 8, fontSize: '20px' }} />}
            borderColor="#1890ff"
            backgroundColor="linear-gradient(135deg, #f0f9ff 0%, #fff 100%)"
            shadowColor="rgba(24, 144, 255, 0.15)"
            companies={companies}
            modelStatus={modelStatus}
          />
          
          <ModelCostDetails companies={companies} modelStatus={modelStatus}/>
          <CostSummary companies={companies} modelStatus={modelStatus}/>
        </Content>
      </Layout>
    </>
  );
};

export default withRouter(ModelingCostReport);